import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=64f77dec&scoped=true"
import script from "./Documentation.vue?vue&type=script&lang=ts"
export * from "./Documentation.vue?vue&type=script&lang=ts"
import style0 from "./Documentation.vue?vue&type=style&index=0&id=64f77dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f77dec",
  null
  
)

export default component.exports